export const ALIGNLEFT = 'alignLeft';